import { gql } from "@apollo/client";

export const GET_EDUCATION_REWARD_FOR_ATTENDEES = gql`
  query GetEducationRewardForAttendees($id: String!, $locale: String) {
    content {
      findById(id: $id, locale: $locale) {
        ... on EducationReward {
          _id
          n
          sl
          type
          data {
            category
            bookingLink
            distributor
            qualifyingTiers
          }
          ecommerce {
            price {
              amount
              currency
            }
            fullPrice {
              amount
              currency
            }
          }
        }
      }
    }
  }
`;

export const GET_POINTS_BALANCE = gql`
  query GetPointsBalance($locale: String) {
    me {
      pointsBalance
      cart(locale: $locale) {
        items {
          _id
          qty
          product {
            ... on Reward {
              _id
            }
            ... on EducationReward {
              _id
            }
          }
        }
      }
    }
  }
`;

export const ADD_TO_CART_EDUCATION = gql`
  mutation AddToCartEducation($productId: ID!, $qty: Int!, $locale: String) {
    cartItemAdd(productId: $productId, qty: $qty, locale: $locale) {
      _id
      items {
        _id
        qty
        product {
          ... on Reward {
            _id
          }
          ... on EducationReward {
            _id
          }
        }
      }
    }
  }
`;

export const UPDATE_CART_EDUCATION = gql`
  mutation UpdateCartEducation($productId: ID!, $qty: Int!, $locale: String) {
    cartItemUpdate(productId: $productId, qty: $qty, locale: $locale) {
      _id
      items {
        _id
        qty
        product {
          ... on Reward {
            _id
          }
          ... on EducationReward {
            _id
          }
        }
      }
    }
  }
`;

export const UPDATE_CART_ATTENDEES = gql`
  mutation UpdateCartAttendees($productId: ID!, $attendees: [AttendeeInput!]!, $locale: String) {
    cartItemUpdateAttendees(productId: $productId, attendees: $attendees, locale: $locale) {
      _id
      items {
        _id
        data {
          attendees {
            name
            email
          }
        }
      }
    }
  }
`;
